import { useMemo } from "react";
import { useWatch } from "react-hook-form";

import { useDraftProviderOptions } from "@RequestFormV2/hooks/useDraftProviderOptions";
import { ProviderOption } from "@RequestFormV2/sections/Provider/types";
import { isProviderEntrySelected } from "@RequestFormV2/sections/Provider/utils/getProviderSelectionKey";

const MAX_AVATARS = 6;

export function useProviderHeaderSummary({ enabled = true }: { enabled?: boolean } = {}) {
  const selectedProviders: string[] = useWatch({ name: "invited_providers.providers" }) ?? [];
  const { providerOptions } = useDraftProviderOptions({ enabled });

  return useMemo(() => {
    const matchedProviders = providerOptions.filter((provider) => isProviderEntrySelected(provider, selectedProviders));
    const count = matchedProviders.length;
    const avatars: ProviderOption[] = matchedProviders.slice(0, MAX_AVATARS);
    const overflowCount = Math.max(0, count - avatars.length);

    return { count, avatars, overflowCount };
  }, [providerOptions, selectedProviders]);
}
